import { Link } from 'react-router-dom'
import DefaultButton from '../../components/DefaultButton'
import DefaultLink from '../../components/DefaultLink';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BaseUrl } from "../../helper/BaseUrl";
import { useModal } from '../../contexts/ModalContext';

export default function GetInTouch() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    service: "",
  });

  const [formData, setFormData] = useState({
    form_type: "contact_form",
    name: "",
    email: "",
    phone: "",
    message: "",
    ip_address: "",
    service: "",
    agree: false,
    source_url: sourceUrl,
    current_url: currentUrl,
  })

  useEffect(() => {
    fetch("https://api64.ipify.org?format=json")
      .then(res => res.json())
      .then(data => {
        setFormData(prev => ({
          ...prev,
          ip_address: data.ip
        }));
      })
      .catch(err => {
        console.error("Failed to fetch IP address", err);
      });
  }, []);


  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedValue = value;
    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "");
    }
    if (name === "name") {
      updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : updatedValue,
      source_url: sourceUrl,
      current_url: currentUrl,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
      form: "",
    }));
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!formData.service) {
      newErrors.service = "Please select a service";
    }

    if (!formData.phone) {
      newErrors.phone = "Mobile number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Mobile number must be 10 digits";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.agree) {
      newErrors.agree = "Please accept privacy policy";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }
    setErrors((prev) => ({
      ...prev,
      ...newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}api/contact/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (result.error === false) {
        toast.success(result.message || "Form submitted successfully");

        setTimeout(() => {
          navigate("/thank-you");
        }, 1000);
      } else {
        setErrors((prev) => ({
          ...prev,
          form: result.message || "Submission failed",
        }));
      }
    } catch (error) {
      console.error("Error:", error);

      setErrors((prev) => ({
        ...prev,
        form: "Something went wrong while submitting the form.",
      }));
    } finally {
      setLoading(false);
    }
  };

  const {openQueryModal} = useModal();

  return (
    <>
      <section className='contact-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div className='contact-left-area'>
                <img src='/assets/images/get-in-touch.webp' alt='Icon'/>
                <h1 className='heading'>Get in Touch</h1>
                <p>Connect with the Dox and Box team for secure, efficient, scalable document management solutions tailored to your business needs. Whether you’re looking to streamline records, enhance data security, or transition to a digital-first approach, get in touch with our experts they are here to help.</p>
                <div>
                  <span>
                    <img src='/assets/images/phonee.webp' alt='Icon'/>
                    <Link target='_blank' to={"tel:+91-9580 374 374"}>+91-9580 374 374</Link>
                  </span>
                  <span>
                    <img src='/assets/images/email.webp' alt='Icon'/>
                    <Link target='_blank' to={"mailto:info@doxandbox.com"}>info@doxandbox.com</Link>
                  </span>
                </div>
              </div>

              <div className="connect-section">
                <h3 className="heading">More Ways To Connect</h3>
                <div className="connect-grid">
                  <div>
                    <span>DOCS</span>
                    <p>Products Guides</p>
                    <DefaultLink onClick={openQueryModal} text='View User Docs' />
                  </div>

                  <div>
                    <span>SUPPORT</span>
                    <p>Let Us Help</p>
                    <DefaultLink onClick={openQueryModal} text='Support portal' />

                  </div>

                  <div>
                    <span>INVESTORS</span>
                    <p>Contact IR</p>
                    <DefaultLink onClick={openQueryModal} text='Learn More' />

                  </div>

                  <div>
                    <span>MEDIA INQUIRIES</span>
                    <p>Reach Out</p>
                    <DefaultLink onClick={openQueryModal} text='Contact Team' />
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <div className='contact-formarea'>
                <h2 className='heading'>Contact Us</h2>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label>full name<span>*</span></label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" required />
                      {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Business Email<span>*</span></label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" required />
                      {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Phone Number<span>*</span></label>
                      <div className="form-field">
                        <input name="phone" type="tel" value={formData.phone} onChange={handleChange} minLength={10} maxLength={10} required className="form-control" />
                        {errors.phone && <p className="error-message">{errors.phone}</p>}
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div >
                        <label>Select Service<span>*</span></label>
                        <select name="service" value={formData.service} onChange={handleChange} className="form-control" required>
                          <option value="">Select Any</option>
                          <option value="Records Management">Records Management</option>
                          <option value="Document Digitization">Document Digitization</option>
                          <option value="Document Destruction">Document Destruction</option>
                          <option value="Insolvency Storage">Insolvency Storage</option>
                          <option value="Vault Storage">Vault Storage</option>
                          <option value=" Cloud Storage"> Cloud Storage</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12 mb-3">
                      <div >
                        <label>Enter Message<span>*</span></label>
                        <textarea rows={3} name="message" value={formData.message} onChange={handleChange}  className="form-control" required />
                        {errors.message && <p className="error-message">{errors.message}</p>}
                      </div>
                    </div>
                    <p>You may be contacted regarding Dox and Box products or services as per our Privacy Policy. Unsubscribe anytime.</p>
                  </div>
                  <div >
                    <div className="contact-form-check">
                      <input className="form-check-input" type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} required />
                      <label>
                        I agree to the Dox and Box Privacy Policy.
                      </label>
                      {errors.agree && <p className="error-message">{errors.agree}</p>}
                    </div>
                  </div>
                  <button style={{ opacity: loading ? "0.3" : "1" }} disabled={loading} type="submit" className="default-btn color-btn"> {loading ? "Submitting..." : "Submit"} </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
